// extracted by mini-css-extract-plugin
export var headerCss = "default-module--headerCss--8b4ca";
export var titleCss = "default-module--titleCss--62d27";